import Joi from 'joi';

export const sellVehicleActionSchema = () =>
	Joi.object({
		soldAt: Joi.date().allow(null).messages({
			'date.base': 'validations|sell-vehicle-action|sold-at-invalid',
		}),

		saleAskPrice: Joi.number().min(0).allow(null).messages({
			'number.base': 'validations|sell-vehicle-action|price-must-be-number',
			'number.min':
				'validations|sell-vehicle-action|price-must-be-non-negative',
		}),

		saleSoldPrice: Joi.number().min(0).allow(null).messages({
			'number.base': 'validations|sell-vehicle-action|price-must-be-number',
			'number.min':
				'validations|sell-vehicle-action|price-must-be-non-negative',
		}),

		purchasedAt: Joi.date().allow(null).messages({
			'date.base': 'validations|vehicle-purchased-at|must-be-a-valid-date',
		}),

		purchaseListPrice: Joi.number().min(0).allow(null).messages({
			'number.base': 'validations|vehicle-purchase-list-price|must-be-number',
			'number.min':
				'validations|sell-vehicle-action|price-must-be-non-negative',
		}),

		purchasePaidPrice: Joi.number().min(0).allow(null).messages({
			'number.base': 'validations|vehicle-purchase-paid-price|must-be-number',
			'number.min':
				'validations|sell-vehicle-action|price-must-be-non-negative',
		}),
	}).unknown();
